import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const VacanciesPagination = ({ activePage, setActivePage, countOfPages }) => {

    const handleChange = (event, value) => {
        setActivePage(value);
    };

    return (
        <Stack spacing={2}>
            <Pagination count={countOfPages} page={activePage} onChange={handleChange}
                sx={{
                    '& .MuiPaginationItem-root': {
                        bgcolor: '#f5f5f5',
                        color: 'black',
                    },
                    '& .MuiPaginationItem-root.Mui-selected': {
                        bgcolor: '#4598B1',
                        color: 'white',

                        ' &:hover': {
                            bgcolor: '#AFA2FF',
                        }
                    },
                    '& .MuiPaginationItem-root:hover': {
                        bgcolor: '#AFA2FF',
                    },

                }}
            />
        </Stack>
    );
}

export default VacanciesPagination;